import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cdvActions } from '_actions';
import { PatientHomeCdvHeader, PatientHomeCdvBody } from 'PatientCareCenter/Home/Cdv'
import styles from './Cdv.module.css'
import { CheckBox } from '_components';
import { ScrollDiv } from '_components';
import { CommonButton } from '_components';
import { patientActions } from '_actions';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PatientHomeCdv extends React.Component {

    refreshExternalOutcomes() {
        let hasLimberAvailable = false;
        this.props.refreshFotoEpisodesForPatient(this.props.ptno);
        for (const x in this.props.admissions) {
            if (this.props.admissions[x].limberActive) {
                this.props.loadLimber(this.props.admissions[x].id);
                   hasLimberAvailable = true;
            }
        }
        if(hasLimberAvailable) {
            this.props.refreshLimber('Successfully refreshed patient assessments');
       }
    }

    refreshLimberAssessment() {
       let hasLimberAvailable = false;
       for (const x in this.props.admissions) {
            if (this.props.admissions[x].limberActive) {
                this.props.loadLimber(this.props.admissions[x].id);
                hasLimberAvailable = true;
            }
        }
       if(hasLimberAvailable) {
            this.props.refreshLimber('Successfully refreshed patient assessments');
       }
    }

    render() {
        if (this.props.admissions && Object.keys(this.props.admissions).length > 0) {
            return (
                <div className={styles.cdv_wrapper}>
                    <span className={styles.checkbox_row}>
                        <CheckBox
                            size='extra-small'
                            className={styles.checkbox}
                            checked={this.props.clinicalVisible}
                            label='Clinical Documents'
                            onClick={() => this.props.toggleClinicalDocsVisibility(this.props.ptno)}
                        />
                        <CheckBox
                            size='extra-small'
                            className={styles.checkbox}
                            checked={this.props.fotoVisible}
                            label='Outcomes Assessments'
                            onClick={() => this.props.toggleFotoDocsVisibility(this.props.ptno)}
                        />
                        {this.props.fotoVisible && <CommonButton className={styles.refresh_button} size='smaller' title='Refresh Outcome Assessments' onClick={() => this.props.fotoRefresh ? this.refreshLimberAssessment() : this.refreshExternalOutcomes()} ><FontAwesomeIcon icon={faRefresh} color="white" className={this.props.fotoRefresh ? styles.spinny : ''}></FontAwesomeIcon></CommonButton>}
                    </span>

                    <ScrollDiv divId={this.props.ptno + '_PCC_HOME_ADMISSIONS'} className={styles.admission_wrapper}>
                        {Object.keys(this.props.admissions)
                            .sort((a, b) => {
                                if (this.props.admissions[a].dischargeDate &&
                                    this.props.admissions[b].dischargeDate &&
                                    new Date(this.props.admissions[a].dischargeDate) >
                                    new Date(this.props.admissions[b].dischargeDate)) {
                                    return -1;
                                }
                                if (this.props.admissions[a].dischargeDate &&
                                    this.props.admissions[b].dischargeDate &&
                                    new Date(this.props.admissions[a].dischargeDate).getTime() ===
                                    new Date(this.props.admissions[b].dischargeDate).getTime()) {
                                    return new Date(this.props.admissions[a].startDate) > new Date(this.props.admissions[b].startDate) ? -1 : 1;
                                }
                                else if (this.props.admissions[b].dischargeDate &&
                                    !this.props.admissions[a].dischargeDate) {
                                    return -1;
                                }
                                else if (!this.props.admissions[a].dischargeDate &&
                                    !this.props.admissions[b].dischargeDate &&
                                    new Date(this.props.admissions[a].startDate).getTime() >
                                    new Date(this.props.admissions[b].startDate).getTime()) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            })
                            .map(id => {
                                const result = this.props.admissions[id];
                                return (
                                    <span key={result.id} className={styles.admission}>
                                        <PatientHomeCdvHeader id={result.id} />
                                        <PatientHomeCdvBody id={result.id} />
                                    </span>
                                )
                            })
                        }
                    </ScrollDiv >

                </div>
            );
        } else {
            return (<i>No Admissions Found</i>);

        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleClinicalDocsVisibility: bindActionCreators(cdvActions.toggleClinicalDocsVisibility, dispatch),
        toggleFotoDocsVisibility: bindActionCreators(cdvActions.toggleFotoDocsVisibility, dispatch),
        toggleFoto: bindActionCreators(patientActions.toggleFotoPanelVisibility, dispatch),
        refreshFotoEpisodesForPatient: bindActionCreators(patientActions.refreshFotoEpisodesForPatient, dispatch),
        refreshCdv: bindActionCreators(cdvActions.refreshCdv, dispatch),
        loadLimber: bindActionCreators(patientActions.loadLimberAssessments, dispatch),
        refreshLimber: bindActionCreators(patientActions.refreshLimberAssessmentMsg, dispatch),
    };
}

function mapStateToProps(state) {
    let fotoRefresh = false;
    //set fotorefresh to status for last admission. I'm sure there's a better way to do this...
    for (const x in state.ui.admissions) {
        fotoRefresh = state.ui.admissions[x].fotoRefreshing;
    }
    return {
        fotoRefresh,
        admissions: Object.keys(state.entities.admissions)
            .filter(key => { return state.entities.admissions[key].ptno === state.ui.patients.selectedPtno })
            .map(key => state.entities.admissions[key]),
        clinicalVisible: state.ui.cdvOptions[state.ui.patients.selectedPtno].clinicalDocsVisible,
        fotoVisible: state.ui.cdvOptions[state.ui.patients.selectedPtno].fotoDocsVisible,
        ptno: state.ui.patients.selectedPtno
    };
}

const connectedPatientHomeCdv = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdv);
export { connectedPatientHomeCdv as PatientHomeCdv };